<template>
  <div
    class="activity-header-container"
    :style="{ height: hiddenHeader ? 0 : 'auto' }"
  >
    <div
      class="activity-header"
      :style="{
        paddingTop: stateHeight,
        background: bgColor,
      }"
      v-if="!this.isForPC"
    >
      <van-nav-bar :border="false" :title="title" class="navbar" placeholder>
        <template #left>
          <div class="left">
            <img
              v-if="showBack"
              class="icon-back"
              src="./images/icon-back.png"
              @click="handleBack"
            />
            <div
              v-if="pageConfig.showCitySelector == 1"
              class="location"
              @click="goAddress"
            >
              <span class="location_icon"></span>
              <span>{{ chooseCity }}</span>
              <span class="location_arrow"></span>
            </div>
          </div>
        </template>
        <template #title>
          <span>{{ showTitle ? title : "" }}</span>
        </template>
        <template #right>
          <follow-pop
            :pageConfig="pageConfig"
            :followPopVisible.sync="followPopVisible"
            :giftFlag="giftFlag"
            :giftType="giftType"
          />
          <intention-pop
            :pageConfig="pageConfig"
            :intentionPopVisible.sync="intentionPopVisible"
          />
          <!-- 取关好职专区测试用 -->
          <!-- <span v-if="subscribed" class="unfollow" @click="delSubscribe()">取关</span> -->
          <div v-if="showFollow" class="follow_box" @click="followAct()">
            <!-- <share-svg :componentConfig="shareConfig" /> -->
            <follow-svg :componentConfig="shareConfig" />
            <span :style="{ color: pageConfig.buttonColor }">关注</span>
          </div>
          <!-- 活动页没有关联专区ID 或 用户已关注活动页（0110版本新增逻辑） -->
          <div
            class="right_class"
            :class="{ right_class2: !showShare || !showWechatNotice }"
          >
            <span>
              <WechatNotice
                v-if="showWechatNotice"
                :wechatStatus="wechatStatus"
              />
            </span>
            <span>
              <share-svg
                class="share_icon"
                v-if="showShare && (!pageConfig.activityZoneId || subscribed)"
                :componentConfig="shareConfig"
              />
            </span>
          </div>
          <div v-if="$route.query.test == 1">
            {{ !pageConfig.activityZoneId }}
            {{ subscribed }}
            {{ platform }}
            {{ platform.includes("App") }}
            {{ followPopVisible }}
          </div>
        </template>
      </van-nav-bar>
    </div>
    <img
      class="activity-banner"
      :style="{
        marginTop: platform != '51jobApp' && platform != 'yjsApp' && !this.isForPC ? '-44px' : 0,
        marginBottom: pageConfig?.customBackground !== 0 && this.isForPC ? '-41px' :pageConfig?.customBackground !== 0 && !this.isForPC ? '-90px' : 0 ,
      }"
      :src="headIconUrl"
    />
    <div
      class="title-content"
      :style="{
        top: stateHeight,
        paddingTop: subTitle ? '56px' : '46px',
      }"
      v-if="pageConfig?.customBackground === 0"
    >
      <div
        class="main-title"
        :style="{
          color: titleColor,
          fontSize: title.length > 6 ? '36px' : '40px',
        }"
      >
        {{ title }}
      </div>
      <div v-if="title.length < 9" class="sub-title">{{ subTitle }}</div>
    </div>
    <JbsExpectedCityPopup
      :visible.sync="visible"
      :max="1"
      @handleSubmit="handleSubmit"
      :id="idString"
      title="选择城市"
      :hotCityCodeList="hotCityCodeList"
      :componentConfig="componentConfig"
    />
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import ShareSvg from "./components/ShareSvg.vue";
import FollowSvg from "./components/FollowSvg.vue";
import FollowPop from "./components/FollowPop.vue";
import IntentionPop from "./components/IntentionPop.vue";
import WechatNotice from "./components/WechatNotice.vue";
import JbsExpectedCityPopup from "@/components/JbsExpectedCityPopup/index.vue";
import router from "@/router";
export default {
  name: "ActivityHeader",
  components: {
    ShareSvg,
    FollowSvg,
    FollowPop,
    IntentionPop,
    JbsExpectedCityPopup,
    WechatNotice,
  },
  props: {
    pageConfig: {
      type: Object,
      default: () => {},
    },
    componentConfig: {
      type: Object,
      default: () => {},
    },
    intention: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isFixed: false,
      showBack: false,
      showTitle: false,
      showShare: false,
      headIconUrl: "",
      title: "",
      subTitle: "",
      stateHeight: 0,
      bgColor: "",
      titleColor: "",
      shareConfig: {},
      visible: false,
      idString: "21",
      chooseCity: "",
      hotCityCodeList: [],
      wechatStatus: false,
      hiddenHeader: false,
      followPopVisible: false,
      intentionPopVisible: false,
      subscribed: false,
      subscriptionId: 0,
      wechatQRCode_follow: false,
      unSubscribeGoodIds:[],//所有未关注的专区
      giftFlag:false, //是否显示赠送气泡
      giftType:'1', //奖励类型 1：谁对我感兴趣  2：简历刷新五次
      showFollow: false, // 是否显示关注按钮
    };
  },
  watch: {
    subscribed: {
      handler(newVal) {
        if (newVal) {
          this.viewTime();
        }
      },
      immediate: false,
    },
  },
  computed: {
    ...mapState(["commonStore"]),
    platform() {
      return this.$store.getters.platform;
    },
     isForPC(){
      return this.commonStore.isForPC
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    showMoreSubscribe(){//判断显示哪个关注挽留弹窗（当前专区；所有未关注专区））
      if(this.unSubscribeGoodIds.length > 0 ){
        if(this.unSubscribeGoodIds.length == 1 && this.unSubscribeGoodIds[0].id == this.pageConfig.activityZoneId){
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    },
    showSubscribe(){//点击返回按钮，弹窗显示基本条件
      // 当前打开H5的环境是App或小程序。
      let env = this.platform.includes("App") || this.platform.includes("WX");
      let show = this.isLogin && env;
      return show;
    },
    isSyncZoneId(){//是否同步了好职
       // 当前版本配置开启同步好职专区
      let showJobSync = this.pageConfig.showJobSync == "Y";
      // 当前版本配置关联了专区ID
      let activityZoneId = this.pageConfig.activityZoneId;
      return showJobSync && activityZoneId
    },
    showWechatNotice() {
      // 浏览器：满足下列任一条件。
      //   无法获取到登录态。
      let isLogin = this.isLogin;
      //   可以获取到登录态 且 用户未关注公众号
      let follow = this.wechatQRCode_follow; //用户未关注公众号
      // App或小程序：满足下列任一条件
      //   当前版本配置未关联了专区ID 且 无法获取到登录态
      let condition1 = !this.pageConfig.activityZoneId && !this.isLogin;
      //   当前版本配置未关联了专区ID 且 可以获取到登录态 且 用户未关注公众号
      let condition2 =
        !this.pageConfig.activityZoneId && this.isLogin && !this.subscribed;
      //   当前版本配置已关联了专区ID 且 可以获取到登录态 且 用户已关注专区
      let condition3 =
        this.pageConfig.activityZoneId && this.isLogin && this.subscribed;

      let showWechat_icon;
      if (this.platform.includes("App") || this.platform.includes("WX")) {
        showWechat_icon = condition1 || condition2 || condition3;
      } else {
        showWechat_icon = !isLogin || (isLogin && !follow);
      }
      console.log(showWechat_icon, "showWechat_icon");
    //  this.$emit('getShowWechatIcon', showWechat_icon);
      return showWechat_icon;
    },
    functionCode() {
      return  this.$route.query?.funcCode || this.commonStore.intention.expectFunction || "0000";
    },
    areaCode() {
      return this.commonStore.intention.expectArea;
    },
  },
  created() {
    console.log(this.$route.query.requestId,'requestId')
    this.init();
    //获取关注微信气泡数据
    if(this.isLogin){
      this.getCheckGiftCondition();
    }
  },
  async mounted() {
    await this.getBySubject();
    this.showFollow = this.getFollowStatus()
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    console.log("应届生this.stateHeight>>>>>", this.stateHeight);
    window.addEventListener("visibilitychange", this.visibilitychange);
    window.addEventListener("scroll", this.handleScroll);
    // 暴露关注方法
    this.$EventBus.$on('subscribeEvent',this.followAct);
    // 判断是否关注所有返回专区
    if(this.showSubscribe && this.isSyncZoneId && this.pageConfig.popupConfigDTO && this.pageConfig.popupConfigDTO.subscribeRetention?.length > 0){
      this.getSubscribeInfo();
    }

    // 自动关注
    if(this.$route.query.subscribe === '1' && this.showFollow && !this.subscribed && !this.commonStore.nearbyPopShow) {
      // nearbyPopShow，绕过离家近弹框
      console.log('【调试代码】触发自动关注');
      this.followAct();
    }

    // 暴露返回方法
    this.$EventBus.$on('handleBackEvent', this.handleBack);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("visibilitychange", this.visibilitychange);
    // 销毁关注方法
    this.$EventBus.$off('subscribeEvent',this.followAct);
    // 销毁返回方法
    this.$EventBus.$off('handleBack', this.handleBack);
  },
  methods: {
    //获取关注微信气泡数据
    async getCheckGiftCondition(){
      const res = await this.$api.activity.checkGiftCondition({checkRange: '2,3,4'})
      if(res.status == "1"){
        this.giftFlag = res.resultbody.giftFlag;
        this.giftType = res.resultbody.giftType;
        console.log('yyy获取关注微信气泡数据',res);
        
      }
    },
    ...mapMutations(["setCurrentAreaCode","setSubscribed","setWechatFollow"]),
    init() {
      console.log("shareSVG--> ", this.componentConfig);
      const {
        headIconUrl,
        headIconPcUrl,
        activeCityList,
        // activeCities,
        // defaultCity,
        // prevLink,
        shareDescription,
        shareIcon,
        shareTitle,
        subtitle,
        title,
        hiddenHeader,
        
      } = this.componentConfig;
      this.hiddenHeader = hiddenHeader;
      this.hotCityCodeList = activeCityList;
      // this.title = '主标题';
      // this.subTitle = '副标题副标题副标题副标题乙二酸';
      this.title = title;
      this.subTitle = subtitle;
      this.titleColor = this.pageConfig.titleColor;
      
      if(this.isForPC){
        this.headIconUrl = headIconPcUrl;
      }else{
        this.headIconUrl = headIconUrl;
      }
      this.shareConfig = {
        shareDescription,
        shareIcon,
        shareTitle,
        backgroundColor: this.pageConfig.buttonColor,
      };
      this.showBack = !this.commonStore.searchPage && (this.platform === "51jobApp" || this.platform === "yjsApp");

      if (this.commonStore.specialPage === 0) {
        this.showBack = false
      }

      this.showShare =
        (this.platform === "51jobApp" || this.platform === "yjsApp") && this.commonStore.device != "harmonyApp";
      if (this.platform === "51jobWX" || this.platform === "yjsWX") {
        this.$base.wxSharePost({
          shareDescription,
          shareIcon,
          shareTitle,
        });
      }
      this.getWechatStatus();
    },
    getFollowStatus() {
      // 当前版本配置开启同步好职专区
      let showJobSync = this.pageConfig.showJobSync == "Y";
      // 当前版本配置关联了专区ID
      let activityZoneId = this.pageConfig.activityZoneId;
      // 无法获取到登录态 或 获取到登录态但用户未关注专区。
      let follow = !this.isLogin || !this.subscribed;
      // 当前打开H5的环境是App或小程序。
      let env = this.platform.includes("App") || this.platform.includes("WX");
      
      let show = showJobSync && activityZoneId && follow && env;
      console.log(this.pageConfig, this.platform, "this.pageConfig112");
      if (show) {
        this.$sensors.track("WidgetShow", {
          $element_id: "sensor_bcop_activityfollow",
          contentType: "未关注",
          contentName: this.pageConfig.activityZoneTitle,
          workIntegrityFunc: this.functionCode,
          requestId:this.$route.query.requestId,
        });
      }
      console.log(
        showJobSync,
        activityZoneId,
        !this.isLogin,
        !this.subscribed,
        this.platform,
        "showFollow"
      );
      // show = !this.subscribed
      console.log(show, "showFollow");
      return show;
    },
    async getSubscribeInfo(){//查询用户是否关注了传入的专区
      let goodIds = this.pageConfig.popupConfigDTO.subscribeRetention;
      goodIds.unshift({
        id:this.pageConfig.activityZoneId,
        name:this.pageConfig.activityZoneTitle
      });
      const res = await this.$api.activity.getSubscribeInfo({
        functionCode: this.functionCode,
        subjects: goodIds, //活动id
        areaCode: this.commonStore.currentAreaCode || this.areaCode,
      });
      if(res?.code == "0"){
        this.unSubscribeGoodIds = res.data;
        this.$store.commit("setValueLocalStorage", {
          unSubscribeGoodIds: JSON.stringify(this.unSubscribeGoodIds),
        });
      }
    },
    followAct(variant) {//variant弹窗形式呈现
      if(variant == 'daily'){//滑到第四屏幕
        this.$sensors.track('PopupClick',{
          popupId:'sensor_bcop_screen4popup',
          contentName: this.pageConfig.activityZoneTitle,
          workIntegrityFunc: this.functionCode,
          requestId:this.$route.query.requestId,
        });
      }else if(variant == 'retention' || variant == 'focusMore'){//挽留弹窗
        this.$sensors.track('PopupClick',{
          popupId:'sensor_bcop_returnpopup',
          contentName: this.pageConfig.activityZoneTitle,
          workIntegrityFunc: this.functionCode,
          requestId:this.$route.query.requestId,
          contentType:variant == 'retention'?'关注挽留（单专区）':'关注挽留（多专区）'
        });
      }
      // 1、判断是否登录
      if (!this.isLogin) {
        this.$base.toLogin();
      }
      // 2、判断求职意向
      let intention = this.commonStore.intention;
      console.log(intention, "判断求职意向");
      if (!intention.expectFunction || !intention.expectArea) {
        this.intentionPopVisible = true;
      } else {
        if(variant == 'focusMore'){//关注挽留（多专区）
          this.moreFollowAdd();
        }else{
          //请求关注
          this.followAdd(variant);
        }
      }
    },

    // 关注订阅
    async followAdd(variant) {
      // this.followPopVisible = true;
      if(!variant){
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_activityfollow",
          contentType: "未关注",
          contentName: this.pageConfig.activityZoneTitle,
          workIntegrityFunc: this.functionCode,
          requestId:this.$route.query.requestId,
        });
      }

      let areaCode = this.commonStore.currentAreaCode || this.areaCode;
      areaCode = areaCode.indexOf(',') ? areaCode.split(',')[0] : areaCode;

      const res = await this.$api.activity.followAdd({
        functionCode: this.functionCode,
        subjectId: this.pageConfig.activityZoneId, //活动id
        areaCode: areaCode,
      });
      if (res.status === "1" && res.resultbody) {
        this.followPopVisible = true;
        // this.subscribed = true;
        this.getBySubject();
        if(variant == 'retention'){
          this.$toast("关注成功");
          setTimeout(()=>{
            this.$base.goBack(this.componentConfig?.prevLink);
          },300);
        }
        this.showFollow = false;
        console.log("followAdd", this.followPopVisible);
      } else {
        this.$toast("关注失败，请稍后尝试");
      }
    },
    async moreFollowAdd(){//多专区关注
      let subjectIds = sessionStorage.getItem("subjectIds") ? JSON.parse(sessionStorage.getItem("subjectIds")):[];
      let areaCode = this.commonStore.currentAreaCode || this.areaCode;
      areaCode = areaCode.indexOf(',') ? areaCode.split(',')[0] : areaCode;

      const res = await this.$api.activity.addBatch({
        functionCode: this.functionCode,
        subjectIds: subjectIds, //活动id
        areaCode: areaCode,
      });
      if(+res.status == 1 && res.resultbody.success){
        this.$toast("关注成功");
        this.showFollow = false;
        setTimeout(()=>{
          this.$base.goBack(this.componentConfig?.prevLink);
        },300);
      }
    },
    async viewTime() {
      await this.$api.activity.viewTime({
        groupId: this.pageConfig.activityZoneId,
        functionCode: this.functionCode,
        areaCode: this.commonStore.currentAreaCode || this.areaCode,
      });
    },
    async delSubscribe() {
      const res = await this.$api.activity.delSubscribe({
        id: this.subscriptionId,
      });
      if (res.status === "1" && res.resultbody) {
        this.getBySubject();
        // this.subscribed = false;
      }
    },
    async getBySubject() {
      if (!this.isLogin) {
        return;
      }
      if (!this.pageConfig.activityZoneId) {
        return;
      }
      let areaCode = (this.commonStore.currentAreaCode || this.areaCode) || '000000';
      areaCode = areaCode.indexOf(',') ? areaCode.split(',')[0] : areaCode;
      const res = await this.$api.activity.getBySubject({
        functionCode: this.functionCode || '0000',
        subjectId: this.pageConfig.activityZoneId, //活动id
        areaCode: areaCode,
      });
      if (res.status === "1" && res.resultbody) {
        this.subscribed = res.resultbody.subscribed;
        this.subscriptionId = res.resultbody.id;
        this.setSubscribed(this.subscribed)
      }
    },
    // 监听页面显示隐藏
    async visibilitychange() {
      if (!document.hidden) {
        await this.getWechatStatus();
      }
    },
    async getWechatStatus() {
      const params = {
        fromDomain: this.platform.indexOf("yjs") > -1 ? "yjs" : "51job",
        accountId: this.commonStore.accountId,
        activityId: this.pageConfig.id, //活动id
      };
      console.log(this.pageConfig, this.componentConfig, params, "6666666");
      const res = await this.$api.activity.wechatQRCode(params);
      if (+res?.code == "0") {
        if (this.isLogin) {
          // follow用户有没关注公众号，false/true，accountId传值时 该字段才有意义。如果为true则表示用户已经关注过了，不需要显示右上角图标。
          this.wechatQRCode_follow = res.data.follow;
        }
        //  else {
        //   // 未登录一直显示右上角关注图标
        //   this.showWechatNotice = true;
        // }
        console.log('====开启微信通知状态wechatFollow',res.data.follow)
        this.$store.commit("setValueLocalStorage", {
          wechatFollow: res.data.follow,
          wechatQRImg: res.data.wechatQRImg,
        });
        this.setWechatFollow(res?.data?.follow)
      }
    },
    handleBack() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_return",
      });

      // 判断是否要显示挽留弹窗(关注挽留弹窗单专区、关注挽留弹窗多专区、职位挽留专区)
      let showCondition = false,variant = '';
      if(this.showSubscribe){//弹窗基本显示条件
        if(this.isSyncZoneId){//同步了好职
          if(this.showMoreSubscribe){//满足关注挽留弹窗多专区显示条件
            variant = 'focusMore';
            showCondition = true;
          }else{//判断显示关注挽留弹窗单专区还是职位挽留弹窗
            if(this.pageConfig.popupConfigDTO && this.pageConfig.popupConfigDTO.subscribeRetention?.length > 0 && this.unSubscribeGoodIds.length <= 0 &&  this.pageConfig.popupConfigDTO.jobRetention?.length > 0){//用户配置了关注挽留弹窗&关注所有&配置了职位挽留弹窗            
              variant = 'jobRetention';
              showCondition = true;
            }else{//判断是否显示关注挽留弹窗单专区
              variant = 'retention';
              showCondition = (this.showSubscribe && this.isSyncZoneId && !this.subscribed);
            }
          }
        }else{//未同步好职
          if(this.pageConfig.popupConfigDTO && this.pageConfig.popupConfigDTO.jobRetention?.length > 0){//用户配置了职位挽留弹窗
            variant = 'jobRetention';
            showCondition = true;
          }
        }
      }
      this.$base.adrBackNotice((res,variant)=>{
        if (res) {
          if(variant == 'retention' || variant == 'focusMore'){
            // 埋点
            this.$sensors.track('PopupShow',{
              popupId:'sensor_bcop_returnpopup',
              contentName: this.pageConfig.activityZoneTitle,
              workIntegrityFunc: this.functionCode,
              requestId:this.$route.query.requestId,
              contentType:variant == 'retention'?'关注挽留（单专区）':'关注挽留（多专区）'
            });
          }
          this.$EventBus.$emit('goBackIntercept',variant);
        } else {
          const prevLink = this.componentConfig.prevLink; 
          console.log("走公用返回方法",prevLink);
          this.$base.goBack(prevLink);
        }
      }, showCondition,this.pageConfig.id,variant);
    },
    handleScroll() {
      const headerBgColor = this.pageConfig.hideColor;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.bgColor = headerBgColor;
        this.bgFilter = true;
        if (this.$store.getters.appType !== "weixin") {
          this.showTitle = true;
        }
        // 滑动到第四屏,满足右上角关注按钮显示条件+频控条件:显示加关注弹窗
        if(scrollTop > parseInt(document.body.clientHeight) * 3){
          console.log('yyy滑到第四屏了');
          
          this.$base.adrBackNotice(res=>{
            if (res) {
              // 埋点
              this.$sensors.track('PopupShow',{
                popupId:'sensor_bcop_screen4popup',
                contentName: this.pageConfig.activityZoneTitle,
                workIntegrityFunc: this.functionCode,
                requestId:this.$route.query.requestId,
              });
              this.$EventBus.$emit('goBackIntercept','daily');
            }
          }, (this.showSubscribe && this.isSyncZoneId && !this.subscribed),this.pageConfig.id,'daily'); 
        }
      } else {
        this.bgColor = "";
        this.bgFilter = false;
        this.showTitle = false;
      }
    },
    goAddress() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_cityselect",
      });
      this.visible = true;
    },
    async handleSubmit(e) {
      this.chooseCity = e.val;
      console.log(e, "城市定位");
      this.setCurrentAreaCode(e.code);
      await this.getBySubject(e.code);
      this.showFollow = this.getFollowStatus()
    },
    changeCity(data) {
      this.chooseCity = data;
      this.$store.commit("setValueLocalStorage", {
        areaName: data
      });
    },
  },
};
</script>
<style lang="less" scoped>
.activity-header-container {
  position: relative;
  .activity-header {
    min-height: 44px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    .pc & {
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 999;
      width: 375px;
    }
    .left {
      display: flex;
      .location {
        min-width: 65px;
        height: 26px;
        border-radius: 13px;
        background: rgba(0, 0, 0, 0.36);
        border-radius: 13px;
        text-align: center;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 16px;
        padding: 0 6px;
        font-size: 12px;
        .location_icon {
          width: 14px;
          height: 14px;
          background: url("@/assets/img/activity/location.png");
          background-size: cover;
          margin-right: 2px;
        }
        .location_arrow {
          width: 10px;
          height: 10px;
          background: url("@/assets/img/activity/location_arrow.png");
          background-size: cover;
          margin-left: 1px;
        }
      }
    }
    .unfollow {
      border-radius: 42px;
      opacity: 1;
      background: #ffffff;
      width: 68px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .follow_box {
      border-radius: 42px;
      opacity: 1;
      background: #ffffff;
      width: 68px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-left: 4px;
        font-size: 14px;
        font-weight: 600;
      }
    }
    .right_class {
      display: flex;
      gap: 10px;
      .share_icon {
        margin-left: 10px;
      }
    }
    .right_class2 {
      gap: 0;
    }

    /deep/.van-nav-bar {
      height: 44px;
      width: 100%;
      .van-nav-bar__content {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 12px 0 16px;
        position: relative;
        .van-nav-bar__title {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          font-size: 16px;
        }
      }
    }
    .icon-back {
      display: inline-block;
      width: 24px;
      height: 24px;
    }
    .icon-share {
      display: inline-block;
      width: 26px;
      height: 26px;
    }
  }
  .activity-banner {
    width: 100%;
    height: auto;
    .adapt_pc_widescreen & {
      min-width: 1200px;
    }
  }
  .title-content {
    position: absolute;
    left: 0;
    right: 0;
    padding-top: 56px;
    margin: 0 auto;
    .adapt_pc_widescreen & {
      // padding-top: 86px !important;
      width: 1200px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  @font-face {
    font-family: "alimamashuheiti";
    src: url("https://fecdn.51jobcdn.com/fe/public/2024/08/23/66c830bd2f0e9f222c07fbe1f2863934.ttf")
      format("truetype");
  }
  .main-title {
    width: 310px;
    // height: 56px;
    margin: 0 auto;
    font-family: alimamashuheiti;
    font-size: 39px;
    color: #490000;
    line-height: 44px;
    text-align: center;
    font-style: normal;
    font-weight: 800;
    .adapt_pc_widescreen & {
      font-size: 44px !important;
      width: 380px;
    }
  }
  .sub-title {
    width: 100%;
    height: 21px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1f1f1f;
    line-height: 21px;
    text-align: center;
    font-style: normal;
    margin: 3px auto 0;
    max-width: 222px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .adapt_pc_widescreen & {
      font-size: 16px !important;
      margin: 10px auto 0;
    }
  }
}
</style>
